import { render, staticRenderFns } from "./ShopPresetOption.vue?vue&type=template&id=2787e524"
import script from "./ShopPresetOption.vue?vue&type=script&lang=js"
export * from "./ShopPresetOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports